<template>

    <div v-if="loading">{{ $t("message_loading") }}</div>

    <div v-else class="mb-4 pl-3 pr-3">
      
      <section v-if="stream_id == 0">
        <div class="timeline_border">
          <div v-for="(dateRange, key, index) in streamReleases" v-bind:key="index" class="pl-0 pr-3 pb-0 related pt-0">
            <div class="p-0 mt-2 mb-4">
              <div class="timeline_month rounded-circle text-center text-white pt-2">
                <p>{{ key }}</p>
              </div>
              <div v-for="release in dateRange" v-bind:key="release.id" class="pb-0 related pt-0">
                <div class="p-2 bg-white">
                  <p class="mb-2 heading_grey text-uppercase float-left" v-for="stream in release.streams" v-bind:key="stream.pivot.stream_id">
                    <router-link class="mt-2 heading_grey mr-3" :to="{ name: 'stream', params: { stream_id: stream.pivot.stream_id } }">{{ stream.name }}</router-link>
                  </p>
                  <span class="clearfix"></span>
                  <p class="mb-0 font-weight-bold font_13">{{ release.release_date_time_formatted }}</p>
                  <h3 class="h5 mb-2"><router-link class="a_no_line" :to="{ name: 'release', params: { type: release.release_type_label, release_id: release.id, slug: release.unformatted_slug } }">{{ release.content_title }}</router-link></h3>
                  <p class="mb-2">{{ release.content_subtitle }}</p>
                  <p class="mb-0 font-weight-bold"><router-link :to="{ name: 'ministry', params: { acronym: release.ministry_acronym } }">{{ release.ministry_name }}</router-link></p>
                </div>
               <hr class="timeline_hr">
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <!-- SPECIFIC STREAM -->
      <section v-else>
          <div v-if="stream_id_prop">
            <router-link :to="{ name: 'stream', params: { stream_id: streamReleases.id } }">{{ streamReleases.name }}</router-link>
            <p>{{ streamReleases.description }}</p> 
          </div>
          <div class="timeline_border">
            <div v-for="(dateRange, key, index) in streamReleases.releases" v-bind:key="index" class="p-0 pr-3 related">
              <div class="p-0 mt-2 mb-4">
                  <div class="timeline_month rounded-circle text-center text-white pt-2">
                    <p>{{ key }}</p>
                  </div>
                  <div v-for="release in dateRange" v-bind:key="release.id" class="pt-0 pb-0 related">
                    <div class="pl-2 pr-2 bg-white">
                      <p class="mb-0 font-weight-bold font_13">{{ release.release_date_time_formatted }}</p>
                      <h3 class="h5 mb-2" v-if="routeName != 'release'">
                        <router-link class="a_no_line" :to="{ name: 'release', params: { type: release.release_type_label, release_id: release.id, slug: release.unformatted_slug } }">{{ release.content_title }}</router-link>
                      </h3>
                      <p class="font-weight-bold mb-0" v-else><router-link class="a_no_line" :to="{ name: 'release', params: { type: release.release_type_label, release_id: release.id, slug: release.unformatted_slug } }">{{ release.content_title }}</router-link></p>
                      <p class="mb-2" v-if="routeName != 'release'">{{ release.content_subtitle }}</p>
                      <p class="mb-0 font-weight-bold" v-if="routeName != 'release'"><router-link :to="{ name: 'ministry', params: { acronym: release.ministry_acronym } }">{{ release.ministry_name }}</router-link></p>

                      <div class="clearfix"></div>
                    </div>
                      <hr class="timeline_hr">
                  </div>
                </div>
            </div>
          </div>
      </section>

    </div>

</template>

<script>
export default {
  props: ['stream_id_prop'],

  data () {
    return {
      stream_id: 0,
      streamReleases: null,
      loading: false,
      errored: false
    }
  },
  computed: {
    routeName: function () {
      return this.$route.name
    }
  },
  methods: {
    determineDataToFetch () {
      // If a stream page was landed on (direct url hit), grab the stream_id from the route parameter
      if (this.$route.params.stream_id) {
        this.stream_id = this.$route.params.stream_id
      // else, grab the stream_id if passed as a prop (coming from the release view)
      } else if (this.stream_id_prop) {
        this.stream_id = this.stream_id_prop
      }

      if (this.stream_id == 0) {
        // all streams and their releases
        this.fetchStreamsReleaseData()
      } else {
        // Specific Stream and it's associated releases
        this.fetchSingleStreamReleaseData()
      }
    },
    fetchStreamsReleaseData () {
      this.loading = true
      this.$axios
        .get(process.env.VUE_APP_ROOT_API + 'streams/releases', {
          params: {
            language: this.$root.$i18n.locale
          }
        })
        .then(response => {
          // Get JSON object
          this.streamReleases = response.data
        })
        .catch(error => {
          console.log(error)
          this.errored = true
        })
        .finally(() => (this.loading = false))
    },
    fetchSingleStreamReleaseData () {
      this.loading = true
      this.$axios
        .get(process.env.VUE_APP_ROOT_API + 'streams/' + this.stream_id, {
          params: {
            language: this.$root.$i18n.locale
          }
        })
        .then(response => {
          // Get JSON object
          this.streamReleases = response.data.data

          // If the route name is release, only pull in a max of 3 releases per stream
          if (this.$route.name == 'release') {
            // create a copy of the stream releases
            var clonedReleases = this.streamReleases.releases
            // instantiate a new object, this is where the 3 releases you want, along with their associated month year keys will be stored
            var trimmedReleases = {}
            var counter = 0

            // Continue to loop through the month year keys and their respective releases in the clonedReleases object, and push them into the new trimmedReleases object while counter is less than 3
            for (const key in clonedReleases) {
              if (counter < 3) {
                trimmedReleases[`${key}`] = []
                for (var i = 0; i < clonedReleases[`${key}`].length; i++) {
                  if (counter < 3) {
                    trimmedReleases[`${key}`].push(clonedReleases[`${key}`][i])
                  }
                  counter++
                }
              }
            }

            // Reset streamReleases.releases (our data variable) with the new trimmed releases
            this.streamReleases.releases = trimmedReleases
          }
        })
        .catch(error => {
          console.log(error)
          this.errored = true
        })
        .finally(() => (this.loading = false))
    }
  },
  mounted () {
    this.determineDataToFetch()
  }
}
</script>
